package com.daytimegaming.ourdailyfinances.domain.model

data class ServerEvent(
    val type: String,
    val event: String,
    val dashboardId: String? = null,
    val accountId: String? = null,
)
